// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_3924d19","container":"_8895853","innerContainer":"_a6dfd8c","avatar":"_ad898af","nameContainer":"_d064abd","name":"_05ba21b","backIcon":"_a450817"};